import {gql} from 'apollo-angular';
import {StatusFragment} from "../../fragments/Status";

export const GET_QUIZ_ANSWER_WRONG = gql`
  query GetQuizAnswerWrong($gameId: Int!, $questionId: Int!) {
    getQuizAnswerWrong(gameID: $gameId, questionID: $questionId){
      status {
        ...statusFields
      }
      answerIds
    }
  }
  ${StatusFragment}
`;
